<template>
  <NavbarFive class="home_one" />
  <ResponsiveNavbarFive class="home_one" />
  <PageBanner pageTitle="Shop" mainTitle="Shop" />
  <ShopItems />
  <DownloadTheApp />
  <MainFooter />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import NavbarFive from "../components/Layouts/NavbarFive.vue";
import ResponsiveNavbarFive from "../components/Layouts/ResponsiveNavbarFive.vue";
import PageBanner from "../components/Common/PageBanner.vue";
import ShopItems from "../components/Shop/ShopItems.vue";
import DownloadTheApp from "../components/Common/DownloadTheApp.vue";
import MainFooter from "../components/Layouts/MainFooter.vue";

export default defineComponent({
  name: "ShopPage",
  components: {
    NavbarFive,
    ResponsiveNavbarFive,
    PageBanner,
    ShopItems,
    DownloadTheApp,
    MainFooter,
  },
});
</script>